import React from 'react';
import styled, {css} from 'styled-components';
import {Typography} from '@fupa/fupa-uikit';

const backToOptionsHeight = '2.25rem';

const Wrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding-top: 1.25rem;
  text-align: center;
  @media screen and (min-width: 500px) {
    padding: 0 2.5rem;
  }
  ${props =>
    props.scrollable &&
    css`
      overflow: scroll;
    `}
`;

const Headline = styled(Typography)`
  margin: ${props => (props.setMargin ? `${backToOptionsHeight} 0 2rem 0` : '0 0 2rem 0')};
`;

const Subtitle = styled(Typography)`
  margin-bottom: ${props => (props.setMargin ? `${backToOptionsHeight}` : '0')};
`;

const TeaserMainLayout = ({backToOptions, title, subtitle, children, scrollable}) => {
  const sub = subtitle ? (
    <Subtitle setMargin={!backToOptions} variant='body2'>
      {subtitle}
    </Subtitle>
  ) : null;

  const showTitle = title ? (
    <Headline setMargin={!backToOptions && !subtitle} variant='title2' component='h2'>
      {title}
    </Headline>
  ) : null;

  return (
    <Wrapper scrollable={scrollable}>
      {backToOptions}
      {showTitle}
      {sub}
      {children}
    </Wrapper>
  );
};

export {TeaserMainLayout};
